export default function () {
  return {
    canInteract: true,
    posActive: false,
    posMessage: null,
    isBooting: true,
    language: 'en',
    config: null,
  };
}
